import { render, staticRenderFns } from "./tiedCardForm.vue?vue&type=template&id=5cf7f60e"
import script from "./tiedCardForm.vue?vue&type=script&lang=js"
export * from "./tiedCardForm.vue?vue&type=script&lang=js"
import style0 from "./tiedCardForm.vue?vue&type=style&index=0&id=5cf7f60e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports